var React = require('react');

function VideoPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.5085 25.9938l18.2346-11.071c.9441-.5732 1.2448-1.8033.6716-2.7475a2 2 0 0 0-.6716-.6716L3.5085.4327C2.5644-.1405 1.3343.1602.761 1.1043a2 2 0 0 0-.2904 1.038v22.1419c0 1.1046.8954 2 2 2a2 2 0 0 0 1.038-.2904z"}));
}

VideoPlay.defaultProps = {"width":"23","height":"27","viewBox":"0 0 23 27"};

module.exports = VideoPlay;

VideoPlay.default = VideoPlay;
